import {
    GET_SCHEDULED_FORMS,
    POST_SCHEDULED_FORM,
    PATCH_SCHEDULED_FORM,
    DELETE_SCHEDULED_FORM
  } from "resources/ApiUrls"
  import MyAxiosInstance from "utils/MyAxiosInstance"
  
  const getAll = (centerId) => MyAxiosInstance.get(GET_SCHEDULED_FORMS(centerId))
  
  const create = (formObj) => MyAxiosInstance.post(POST_SCHEDULED_FORM, formObj)
  
  const update = (formObj, formId) => MyAxiosInstance.patch(PATCH_SCHEDULED_FORM(formId), formObj)
  
  const deleteScheduledForm = (formId) => MyAxiosInstance.delete(DELETE_SCHEDULED_FORM(formId))
  
  const scheduledFormsAPICalls = { getAll, create, update, deleteScheduledForm }
  
  export default scheduledFormsAPICalls
  